import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordMatchValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const newPinControl = group.get('new_pin');
    const confirmPinControl = group.get('confirm_pin');

    const newPass = newPinControl ? newPinControl.value : null;
    const confirmPass = confirmPinControl ? confirmPinControl.value : null;

    if (!newPass || !confirmPass) {
      return null;
    }

    if (newPass === confirmPass) {
      return null;
    }

    return { passwordMismatch: true };
  };
}

export function passwordNotSameAsOldValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const oldPinControl = group.get('old_pin');
    const newPinControl = group.get('new_pin');

    const oldPass = oldPinControl ? oldPinControl.value : null;
    const newPass = newPinControl ? newPinControl.value : null;

    if (!oldPass || !newPass) {
      return null;
    }

    if (oldPass === newPass) {
      return { sameAsOld: true };
    }

    return null;
  };
}

export function passwordNotContainUsernameValidator(username: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const newPinControl = group.get('new_pin');
    const newPass = newPinControl ? newPinControl.value : null;

    if (!newPass || !username) {
      return null;
    }

    const lowerPassword = String(newPass).toLowerCase();
    const lowerUsername = String(username).toLowerCase();

    if (lowerPassword.indexOf(lowerUsername) !== -1) {
      return { containsUsername: true };
    }

    return null;
  };
}